import { evaluateConditions } from '../evaluateConditions';
import * as yup from 'yup';
import { removeEmptyConditions } from './removeEmptyConditions';

export const maybeAddOptionalityToSchema = (
  schema,
  variable,
  allVariables,
  allOptional,
  parentSiblingValues = undefined,
) => {
  if (!variable.required || (allOptional && !variable.requiredWhen)) {
    return schema.notRequired().nullable();
  }

  if (removeEmptyConditions(variable.requiredWhen)) {
    const varsKeys = allVariables
      .filter(v => !removeEmptyConditions(v.requiredWhen))
      .map(v => v.name);

    if (varsKeys.length > 0) {
      return schema.when(varsKeys, (_varsValues, schemaNested) => {
        const varsValues = parentSiblingValues || _varsValues;
        const contractValues = varsKeys.reduce((previous, key, index) => {
          previous[key] = varsValues[index];
          return previous;
        }, {});

        const shouldBeRequired = evaluateConditions(
          variable.requiredWhen,
          allVariables,
          contractValues,
        );

        if (shouldBeRequired && !allOptional) {
          return schemaNested;
        }

        if (shouldBeRequired && allOptional) {
          return schemaNested.notRequired().nullable();
        }

        return yup.mixed().notRequired().nullable();
      });
    }
  }

  return schema;
};
